"use client";

import dynamic from "next/dynamic";

/**
 * Lazy client-side mount of the snap-only debug panel: its code loads only
 * where it actually renders, so it never rides in the initial bundle of a
 * page that will not show it. `InstrumentationProvider` is the single place
 * that renders this; the hostname gate lives in the panel itself.
 */
export const LazyInstrumentationDebugPanel = dynamic(
  () =>
    import("@/components/instrumentation/InstrumentationDebugPanel/InstrumentationDebugPanel").then(
      (module) => module.InstrumentationDebugPanel,
    ),
  { ssr: false },
);
